import { Injectable } from '@angular/core';

import { IdentifyUserForAnalyticsCmd } from '../command/identify-user-for-analytics.cmd';

@Injectable()
export abstract class UserAnalyticsPort {
	public abstract identifyUserForAnalytics(cmd: IdentifyUserForAnalyticsCmd);
	public abstract markUserConversationAsShown();
}
